let vA524 = [{
  name: "Burg",
  fileName: "burg_new"
}, {
  name: "Littletown",
  fileName: "littletown"
}, {
  name: "Sandstorm",
  fileName: "sandstorm_v3"
}, {
  name: "Subzero",
  fileName: "subzero_new"
}, {
  name: "Undergrowth",
  fileName: "undergrowth"
}, {
  name: "Shipment",
  fileName: "shipment"
}, {
  name: "Freight",
  fileName: "freight"
}, {
  name: "Lostworld",
  fileName: "lostworld_s6"
}, {
  name: "Citadel",
  fileName: "citadel"
}, {
  name: "Oasis",
  fileName: "oasis_v3"
}, {
  name: "Kanji",
  fileName: "kanji"
}, {
  name: "Industry",
  fileName: "industry"
}, {
  name: "Lumber",
  fileName: "lumber"
}, {
  name: "Evacuation",
  fileName: "evacuation"
}, {
  name: "Site",
  fileName: "site"
}, {
  name: "SkyTemple",
  fileName: "skytemple_v2"
}, {
  name: "Lagoon",
  fileName: "lagoon"
}, {
  name: "Bureau",
  fileName: "bureau"
}, {
  name: "Tortuga",
  fileName: "shipwrecked"
}, {
  name: "Tropicano",
  fileName: "tropicano"
}, {
  name: "Krunk_Plaza",
  fileName: "krunk_plaza_v2"
}, {
  name: "Arena",
  fileName: "arena"
}, {
  name: "Habitat",
  fileName: "habitat_v2"
}, {
  name: "Atomic",
  fileName: "atomic"
}, {
  name: "Old_Burg",
  fileName: "burg_2018"
}, {
  name: "Throwback",
  fileName: "throwback_2018"
}, {
  name: "Stockade",
  fileName: "stockade_2018"
}, {
  name: "Facility",
  fileName: "facility"
}, {
  name: "Clockwork",
  fileName: "clockwork"
}, {
  name: "Laboratory",
  fileName: "laboratory"
}, {
  name: "Shipyard",
  fileName: "shipyard"
}, {
  name: "Soul Sanctum",
  fileName: "sanctum"
}];
module.exports = () => false ? undefined : vA524;